import 'bootstrap/js/src/util';
import 'bootstrap/js/src/tab';
import 'bootstrap/js/src/collapse';
import Vue from 'vue';
import ApplicationForm from './vue/ApplicationForm.vue';
import 'slick-slider';

require('smoothscroll-polyfill').polyfill();

// eslint-disable-next-line
window.__forceSmoothScrollPolyfill__ = true;

if (document.querySelector('#formApp')) {
  // eslint-disable-next-line
  new Vue({
    el: '#formApp',
    components: { ApplicationForm },
  });
}

$('.scroll-to-form').on('click', (e) => {
  e.preventDefault();

  const form = document.querySelector('.home-hero, .subpage-hero');

  form.scrollIntoView({ behavior: 'smooth' });
});

$('.form-postcode').on('submit', (e) => {
  if (!e.target.dataset.postcodes || !e.target.elements.ppc) {
    return null;
  }

  const patterns = JSON.parse(e.target.dataset.postcodes);
  const postcode = e.target.elements.postcode.value.replace(/\s/g, '');
  let withinArea = false;

  patterns.forEach((pattern) => {
    if (postcode.startsWith(pattern)) {
      withinArea = true;
    }
  });

  if (!withinArea) {
    e.target.elements.ppc.disabled = true;
  }

  return true;
});

$('section.home-hero .insulation-types').slick({
  arrows: false,
  dots: false,
  infinite: false,
  swipe: false,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        variableWidth: false,
        autoplay: true,
        slideToShow: 1,
      },
    },
  ],
});
